import {
  AllocationUnit,
  ConversionSource,
  convertAllocationQuantity,
  normalizeQuantityUnit,
} from './dimensionConversion';

export const COMMERCIAL_UNITS: readonly AllocationUnit[] = ['pcs', 'm2', 'm3'] as const;
export const COMMERCIAL_PRICING_CONVERSION_UNITS: readonly AllocationUnit[] = ['m2', 'm3'] as const;
export const MAX_CUSTOMER_PHYSICAL_QUANTITY = 1_000_000;
export const MAX_CUSTOMER_PRICING_QUANTITY = 99_999_999_999.999;

export interface CommercialQuantityValue {
  physicalQuantity: number;
  physicalUnit: AllocationUnit;
  pricingQuantity: number;
  pricingUnit: AllocationUnit;
}

export function asCommercialUnit(value: unknown, fallback: AllocationUnit = 'pcs'): AllocationUnit {
  const normalized = normalizeQuantityUnit(String(value || fallback));
  return (COMMERCIAL_UNITS as readonly string[]).includes(normalized)
    ? normalized as AllocationUnit
    : fallback;
}

export function roundCommercialQuantity(value: number): number {
  return Math.round((Number(value) + Number.EPSILON) * 1000) / 1000;
}

export function convertCommercialQuantity(
  quantity: number,
  sourceUnit: AllocationUnit,
  targetUnit: AllocationUnit,
  dimensions: ConversionSource,
): { value: number | null; exactValue: number | null; error: string | null } {
  const result = convertAllocationQuantity({
    ...dimensions,
    quantity,
    sourceUnit,
    targetUnit,
  });

  return {
    value: result.exactValue == null ? null : roundCommercialQuantity(result.exactValue),
    exactValue: result.exactValue,
    error: result.error,
  };
}
